// @flow
import { CONFERENCE_LEFT, SET_GROUP_UUID } from '../conference';
import { ReducerRegistry } from '../redux';
import {
    DELETE_PIN_PARTICIPANT, DOMINANT_SPEAKER_CHANGED, PARTICIPANT_JITSI_ID, PARTICIPANT_JOINED,
    PARTICIPANT_LEFT,
    PARTICIPANT_UPDATED,
    PIN_PARTICIPANT, SET_BRIDGE_PARTICIPANT,
    SET_GROUP_PARTICIPANT, SET_RECORDING_PARTICIPANT
} from './actionType';
import { PARTICIPANT_STATUS, ROLE } from './constants';

/**
 * local: 본인
 * remote: 다른 참가자
 * pinnedParticipant: pin된 사용자
 * hostParticipant 방장( 강사 )
 * recordParticipant:  녹화중인 사용자
 * dominantSpeaker: 메인 토커?
 */
const DEFAULT_STATE = {
    local: undefined,
    pinnedParticipant: new Set(),
    hostParticipant: new Set(),
    recordParticipant: new Set(),
    dominantSpeaker: undefined,

    remote: new Map(),
    group: new Map(),
    bridgeParticipant: new Map()
};

ReducerRegistry.register('features/base/participants', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case CONFERENCE_LEFT:
            return {
                local: undefined,
                pinnedParticipant: new Set(),
                hostParticipant: new Set(),
                recordParticipant: new Set(),
                dominantSpeaker: undefined,
                bridgeParticipant: new Map(),
                group: new Map(),
                remote: new Map()
            };

        case SET_GROUP_UUID:
            return {
                ...state,
                pinnedParticipant: new Set(),
                hostParticipant: new Set(),
                dominantSpeaker: undefined,
            }

        case SET_GROUP_PARTICIPANT:
            return {
                ...state,
                group: action.particiapnt
            }

        case SET_BRIDGE_PARTICIPANT:
            state.bridgeParticipant.set(action.user_id, action.bridge_session_id);
            
            return Object.assign({}, { ...state });

        case PARTICIPANT_JOINED: {
            const { participant, isLocal, group_id } = action;

            // host 추가 
            if (participant.role === ROLE.HOST || participant.role === ROLE.ADMIN) state.hostParticipant.add(participant.user_uuid);
            // 본인인 경우 
            if (isLocal) { 
                participant.jitsi_id = "local";

                return Object.assign({}, state, { local: participant });
            } 
        
            if (state.remote.get(participant.user_uuid)) {
                state.remote.delete(participant.user_uuid);    
            } 
            
            state.remote.set(participant.user_uuid, participant);
            return { ...state };
        }

        case PARTICIPANT_UPDATED: {
            const { participant } = action;
            if (!participant) return { ...state };

            let { user_uuid, local } = participant;

            if (local) {
                return { ...state, local: participant };
            } else {
                const prevMember = state.remote.get(user_uuid);
                if (prevMember) {
                    const newParticipant = _participant(prevMember, action);                  

                    return Object.assign({ ...state }, { remote: new Map( state.remote.set(user_uuid, newParticipant)) });
                }
            }

            return Object.assign({}, { ...state });           
        }

        case PARTICIPANT_JITSI_ID:
            const { participant } = action;
            if (!participant) return;
            let { user_uuid: id } = participant;

            let newParticipant;
            if (state.remote.has(id)) {
                newParticipant = _participant(state.remote.get(id), action);
                state.remote.set(id, newParticipant);
            } else if (id === state.local?.user_uuid) {
                state.local = _participant(state.local, action);
            }

            return Object.assign({}, { ...state });    

        case PARTICIPANT_LEFT: {
            const prevMember = action.participant;
            const user_uuid = prevMember.user_uuid;

            if (prevMember) {
                state.remote.set(user_uuid, { ...prevMember, status: PARTICIPANT_STATUS.VACATED });
                if (prevMember.role === ROLE.HOST || prevMember.role === ROLE.ADMIN) state.hostParticipant.delete(user_uuid);
            }

            if (state.dominantSpeaker === user_uuid) state.dominantSpeaker = undefined;
            if (state.pinnedParticipant.has(user_uuid)) state.pinnedParticipant.delete(user_uuid);
            
            return Object.assign({}, { ...state });
        }

        case PIN_PARTICIPANT: {
            const { participantId } = action;
            if (state.remote.has(participantId) || state?.local?.user_uuid === participantId) {
                state.pinnedParticipant.add(participantId);
            }

            return Object.assign({}, { ...state });
        }
        
        case DELETE_PIN_PARTICIPANT: {
            const { participantId } = action;
            state.pinnedParticipant.delete(participantId);

            return Object.assign({}, { ...state });
        }

        case SET_RECORDING_PARTICIPANT: {
            const { participantId, record } = action;

            if (record) state.recordParticipant.add(participantId);
            else state.recordParticipant.delete(participantId);
            
            return Object.assign({}, { ...state });
        }

        case DOMINANT_SPEAKER_CHANGED: {
            const { user_uuid } = action;

            state.dominantSpeaker = user_uuid;
            
            return Object.assign({}, { ...state });
        }
    
        default: 
            return {
                ...state
            };
    }
    
});

function _participant(state, action) {
    switch (action.type) {
        case PARTICIPANT_UPDATED: {
            const { participant } = action; // eslint-disable-line no-shadow

            const newState = { ...state };

            for (const key in participant) {
                if (participant.hasOwnProperty(key)) {
                    newState[key] = participant[key];
                }
            }

            return newState;
        }
    }

    return state;
}

// StateListenerRegistry.register(state => state['features/base/participants'].remote,
//     (remote, store) => {
//         const conferenceJoined = getCurrentConference(store.getState());
        
//         conferenceJoined && store.dispatch(getGroup());
//     }
// );